import { SegmentedControl } from './ui';
import { useThemePreference, writeThemePreference, type ThemePreference } from './theme';

const OPTIONS: { value: ThemePreference; label: string }[] = [
  { value: 'light', label: 'Clair' },
  { value: 'dark', label: 'Sombre' },
  { value: 'system', label: 'Système' },
];

/**
 * Réglage du thème (US-24). §4 exige « thème sombre disponible » ; suivre
 * `prefers-color-scheme` sans recours n'est pas une disponibilité — en cuisine
 * le besoin change dans la journée, et l'écran reste allumé en continu.
 *
 * Trois boutons plutôt qu'une liste déroulante : §4 proscrit les menus
 * déroulants là où l'on touche l'écran les mains occupées, et trois options
 * tiennent sans replier.
 */
export function ThemeToggle(): React.JSX.Element {
  const current = useThemePreference();
  return (
    /* `SegmentedControl` et non trois `<Button>` (refonte éditoriale). US-54
       avait déjà remplacé ici trois `<button>` habillés à la main par la
       primitive, ce qui a apporté le focus, l'état pressé et le `:disabled`
       qui manquaient. Restait le point de vérité de « sélectionné » :
       `variant="primary"`, c'est-à-dire l'aplat orange plein réservé à
       l'action que la page existe pour faire. Sur les réglages, il y en avait
       trois — thème, unités, voix — soit trois taches d'accent qui ne
       marquaient aucune action.

       Le composant rend la même sémantique qu'ici (`radiogroup` + `radio`) et
       y ajoute ce qu'un groupe de boutons radio doit avoir et qu'une rangée de
       boutons n'a pas : la navigation aux flèches et un seul arrêt de
       tabulation. */
    <SegmentedControl
      label="Thème"
      value={current}
      onChange={writeThemePreference}
      options={OPTIONS.map((option) => ({ value: option.value, label: option.label }))}
      className="self-start"
    />
  );
}
